import produce from 'immer';
import uuid from 'uuid-random';

import { NOTIFICATION_TYPES } from '../constants';
import { HIDE_NOTIFICATION, SHOW_NOTIFICATION } from './actions';

export const defaultState = {
    notifications: []
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case SHOW_NOTIFICATION: {
            draftState.notifications.push({
                id: action.payload.id || uuid(),
                Icon: action.payload.Icon,
                iconType: action.payload.iconType,
                tKey: action.payload.tKey,
                message: action.payload.message,
                className: action.payload.className,
                clsName: action.payload.clsName,
                onClose:  action.payload.onClose,
                onClick: action.payload.onClick,
                onAccept: action.payload.onAccept,
                onDecline: action.payload.onDecline,
                onHide: action.payload.onHide,
                acceptTitle: action.payload.acceptTitle,
                declineTitle: action.payload.declineTitle,
                type: action.payload.type || NOTIFICATION_TYPES.DEFAULT,
                displayTime: action.payload.displayTime,
                enableAutoHid: action.payload.enableAutoHid,
                timestamp: Date.now()
            });

            break;
        }
        case HIDE_NOTIFICATION: {
            draftState.notifications = draftState.notifications.filter(n => n.id !== action.payload.id);

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
